import * as React from 'react';
import { Dialog, DialogFooter, DirectionalHint, Dropdown, IconButton, IDropdownOption, Label, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { IStackMarker } from '../../../../models/Maps/IStackMarker';
import { Direction } from 'leaflet';
import { isMobileOrTablet } from '../../../VisibilityControl/UserAgentControl';

export interface IStackDialogProps {
    currentStack: IStackMarker;
    onSaveClicked(identifier: string, no: string, size: number, treeSpecies: string, tooltipPosition: Direction): void;
    onChanged?: (no: string, size: number, treeSpecices: string, tooltipPosition: string) => void;
    onDismiss?: () => void;
}

export interface IStackDialogState {
    no: string; //must be number, so will keep as string to ensure previously created stacks (backward comp.)
    size: number;
    treeSpecices: string;
    tooltipPosition: string;
}

export default class StackDialog extends React.Component<IStackDialogProps, IStackDialogState> {

    constructor(props: IStackDialogProps) {
        super(props);

        this.state = {
            no: this.props.currentStack.no ? this.props.currentStack.no : "",
            size: this.props.currentStack.size ? this.props.currentStack.size : 0,
            treeSpecices: this.props.currentStack.treeSpecices ? this.props.currentStack.treeSpecices : "",
            tooltipPosition: this.props.currentStack.tooltipPosition ? this.props.currentStack.tooltipPosition : "top"
        };
    }

    private renderActionButton() {
        return (
            <PrimaryButton
                style={{ width: '100%', marginBottom: 10, marginTop: -10 }}
                text="Gem på kortet"
                onClick={() => {
                    this.props.onSaveClicked(
                        this.props.currentStack.identifier,
                        this.state.no,
                        this.state.size,
                        this.state.treeSpecices,
                        this.state.tooltipPosition as Direction
                    );
                }}
            />
        );
    }

    public render(): React.ReactElement<IStackDialogProps> {
        return (
            <Dialog
                hidden={false}
                minWidth={200}
                onDismiss={this.props.onDismiss}
                modalProps={{ isBlocking: true }}
                dialogContentProps={{
                    title: (
                        <Stack
                            horizontal
                            horizontalAlign="space-between"
                            verticalAlign="center"
                            style={{ marginBottom: -10 }}
                        >
                            <Label style={{ fontSize: '16px' }}> Angiv stak informationer </Label>
                            <IconButton
                                iconProps={{ iconName: 'Cancel' }}
                                ariaLabel="Luk"
                                onClick={this.props.onDismiss}
                                styles={{ root: { marginRight: -30, marginTop: 5 } }}
                            />
                        </Stack>
                    )
                }}
            >
                {isMobileOrTablet() && (
                    <div style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 100,
                        paddingTop: -30,
                        marginTop: 0,
                    }}>
                        {this.renderActionButton()}
                    </div>
                )}
                <TextField
                    label="Stak nummer"
                    pattern="[0-9]*"
                    description={"Stak nummer skal være et helt tal"}
                    value={this.state.no}
                    onChange={(ev, newValue) => {
                        let v = newValue ? newValue : "0";
                        if ((ev.target as any).validity.valid) {
                            this.setState({ no: parseFloat(v + "") + "" }, () => {
                                if (this.props.onChanged) {
                                    this.props.onChanged(
                                        this.state.no,
                                        this.state.size,
                                        this.state.treeSpecices,
                                        this.state.tooltipPosition
                                    );
                                }
                            });
                        }
                    }}
                />
                <TextField
                    label="Stak størrelse"
                    pattern="[0-9]*"
                    description={"Mængden skal være et helt tal"}
                    value={this.state.size + ""}
                    suffix="rm"
                    onChange={(ev, newValue) => {
                        let v = newValue ? newValue : "0";

                        if ((ev.target as any).validity.valid) {
                            this.setState({ size: parseFloat(v + "") }, () => {
                                if (this.props.onChanged) {
                                    this.props.onChanged(
                                        this.state.no,
                                        this.state.size,
                                        this.state.treeSpecices,
                                        this.state.tooltipPosition
                                    );
                                }
                            });
                        }
                    }}
                />
                <Dropdown
                    placeholder="Vælg fra listen"
                    label="Træart"
                    selectedKey={this.state.treeSpecices}
                    options={[
                        { key: 'Løv', text: 'Løv' },
                        { key: 'Nål', text: 'Nål' },
                        { key: 'Blandet', text: 'Blandet' },
                        { key: 'Pil/poppel', text: 'Pil/poppel' }
                    ]}
                    onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
                        this.setState({ treeSpecices: option?.key + "" }, () => {
                            if (this.props.onChanged) {
                                this.props.onChanged(
                                    this.state.no,
                                    this.state.size,
                                    this.state.treeSpecices,
                                    this.state.tooltipPosition
                                );
                            }
                        });
                    }}
                />
                <Dropdown
                    placeholder="Vælg fra listen"
                    label="Tekst placering"
                    selectedKey={this.state.tooltipPosition}
                    options={[
                        { key: 'top', text: 'I toppen' },
                        { key: 'bottom', text: 'I bunden' },
                        { key: 'left', text: 'Til venstre' },
                        { key: 'right', text: 'Til højre' }
                    ]}
                    onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => { 
                        this.setState({ tooltipPosition: option?.key + "" }, () => {
                            if (this.props.onChanged) {
                                this.props.onChanged(
                                    this.state.no,
                                    this.state.size,
                                    this.state.treeSpecices,
                                    this.state.tooltipPosition
                                );
                            }
                        });
                    }}
                />
                {!isMobileOrTablet() &&
                    <DialogFooter>
                        {this.renderActionButton()}
                    </DialogFooter>
                }
            </Dialog>);
    }
}